export default {
  'processPortal.title': 'Manage Process Portal',

  'processPortal.form.shortenedUrl': 'Shortened Url',
  'processPortal.form.openUrl': 'Open Url',
  'processPortal.form.shortCode': 'ShortCode',

  'processPortal.descriptionProcess': 'The processes that will appear in the portal',
  'processPortal.descriptionReport': 'The reports that will appear in the portal',
  'processPortal.descriptionPermission': 'Access permissions to the portal',
  'processPortal.descriptionList': 'The lists that will appear in the portal',
  'processPortal.descriptionEntity': 'The entities that will appear in the portal',
  'processPortal.descriptionMenu': 'Menu structure for the process portal',
  'processPortal.descriptionProcessWithName':
    'The processes that will appear in the portal {name}.',
  'processPortal.descriptionReportWithName': 'The reports that will appear in the portal {name}.',
  'processPortal.descriptionListWithName': 'The lists that will appear in the portal {name}.',
  'processPortal.descriptionEntityWithName': 'The entities that will appear in the portal {name}.',

  'processPortal.configurations.description':
    'Choose a section to configure content and access for this process portal.',
  'processPortal.configurations.descriptionWithName':
    'Choose a section to configure content and access for {name}.',
  'processPortal.permissions.description':
    'Add or remove who can access the process portal {name}.',
  'processPortal.menu.descriptionWithName':
    'Configure the menu structure for the process portal {name}.',

  'processPortal.form.mainColor': 'Main Color',
  'processPortal.form.logoUrl': 'Logo (Url)',
  'processPortal.form.template': 'Template',
  'processPortal.form.loginSplashUrl': 'Login Splash (Url)',
  'processPortal.form.fontUrl': 'Font (Url)',
  'processPortal.form.iconLogoUrl': 'Icon (Url)',
  'processPortal.form.faviconUrl': 'Favicon (Url)',
  'processPortal.form.permissionsFiltersLogicalOperator': 'Permissions Filters Logical Operator',
  'processPortal.form.hideMenuItemHome': 'Hide Home menu item',
  'processPortal.form.hideMenuItemTasks': 'Hide Tasks menu item',
  'processPortal.form.hideMenuItemRequests': 'Hide Requests menu item',

  'processPortal.menu.customList': 'List',
  'processPortal.menu.customLists': 'All Lists',
  'processPortal.menu.dynamicEntity': 'Dynamic Entity',
  'processPortal.menu.dynamicEntities': 'All Dynamic Entities',
  'processPortal.menu.report': 'Report',
  'processPortal.menu.reports': 'All Reports',
  'processPortal.menu.process': 'Process',
  'processPortal.menu.processes': 'All Processes',
  'processPortal.menu.link': 'Link',
  'processPortal.menu.subMenu': 'Dropdown Menu',
  'processPortal.menu.embedHtml': 'Embedded HTML',
  'processPortal.menu.renderTemplate': 'Render Template',
  'processPortal.menu.parentSubMenu': 'Parent Sub Menu',
  'processPortal.menu.htmlFile': 'HTML File',
  'processPortal.menu.templateLink': 'Template URL',
  'processPortal.menu.preview': 'Preview',

  'processPortal.action.generatePublicUrl': 'Generate Public URL',
  'processPortal.action.deactivatePublicUrl': 'Deactivate Public URL',
};
